import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { LeafletMapProps } from './LeafletMap';

export const MapController = ({ initialCenter, onMove }: Pick<LeafletMapProps, 'initialCenter' | 'onMove'>) => {
  const map = useMap();

  useEffect(() => {
    if (initialCenter && map && window) {
      map.setView([initialCenter.latitude, initialCenter.longitude]);
    }
  }, [initialCenter, map]);

  useEffect(() => {
    if (map && window && onMove) {
      map.on('dragend', (e) => {
        if (e.target) {
          onMove({ latitude: e.target.getCenter().lat, longitude: e.target.getCenter().lng });
        }
      });

      return () => {
        map.off('dragend');
      };
    }
  }, [map]);

  return null;
};
